import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_b3e53afc from 'nuxt_plugin_plugin_b3e53afc' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_c46b1c2c from 'nuxt_plugin_plugin_c46b1c2c' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_toast_dee3e572 from 'nuxt_plugin_toast_dee3e572' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_portalvue_13c46a8a from 'nuxt_plugin_portalvue_13c46a8a' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_pluginutils_353ef0a3 from 'nuxt_plugin_pluginutils_353ef0a3' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_d1743da4 from 'nuxt_plugin_pluginrouting_d1743da4' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_f7276dfe from 'nuxt_plugin_pluginmain_f7276dfe' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_workbox_b47f2098 from 'nuxt_plugin_workbox_b47f2098' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_d94e7a72 from 'nuxt_plugin_metaplugin_d94e7a72' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_axios_77447ed0 from 'nuxt_plugin_axios_77447ed0' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_01vxm_70479b39 from 'nuxt_plugin_01vxm_70479b39' // Source: ../../../plugins/01.vxm.ts (mode: 'client')
import nuxt_plugin_02applyConfig_2aa97d93 from 'nuxt_plugin_02applyConfig_2aa97d93' // Source: ../../../plugins/02.applyConfig.ts (mode: 'client')
import nuxt_plugin_styles_490d6f56 from 'nuxt_plugin_styles_490d6f56' // Source: ../../../plugins/styles.ts (mode: 'client')
import nuxt_plugin_directives_521c0486 from 'nuxt_plugin_directives_521c0486' // Source: ../../../plugins/directives.js (mode: 'client')
import nuxt_plugin_dayjs_66ce609e from 'nuxt_plugin_dayjs_66ce609e' // Source: ../../../plugins/dayjs.ts (mode: 'client')
import nuxt_plugin_dependencyinjectioncontainer_5d884c32 from 'nuxt_plugin_dependencyinjectioncontainer_5d884c32' // Source: ../../../plugins/dependency_injection_container.ts (mode: 'client')
import nuxt_plugin_vuefinalmodal_4feb7cf4 from 'nuxt_plugin_vuefinalmodal_4feb7cf4' // Source: ../../../plugins/vue-final-modal.ts (mode: 'client')
import nuxt_plugin_listofcountries_062e8d14 from 'nuxt_plugin_listofcountries_062e8d14' // Source: ../../../plugins/list-of-countries.ts (mode: 'client')
import nuxt_plugin_fragment_0f1b35a7 from 'nuxt_plugin_fragment_0f1b35a7' // Source: ../../../plugins/fragment.ts (mode: 'client')
import nuxt_plugin_veevalidate_1a0c172c from 'nuxt_plugin_veevalidate_1a0c172c' // Source: ../../../plugins/vee-validate.ts (mode: 'client')
import nuxt_plugin_i18nextendmessages_2cf4d7f2 from 'nuxt_plugin_i18nextendmessages_2cf4d7f2' // Source: ../../../plugins/i18n-extend-messages.ts (mode: 'client')
import nuxt_plugin_assetsurl_121ce59c from 'nuxt_plugin_assetsurl_121ce59c' // Source: ../../../plugins/assets-url.ts (mode: 'client')
import nuxt_plugin_vuequery_264a3842 from 'nuxt_plugin_vuequery_264a3842' // Source: ../../../plugins/vue-query.ts (mode: 'client')
import nuxt_plugin_handleconstraintviolations_74add344 from 'nuxt_plugin_handleconstraintviolations_74add344' // Source: ../../../plugins/handle-constraint-violations.ts (mode: 'client')
import nuxt_plugin_provideToast_5ab8299e from 'nuxt_plugin_provideToast_5ab8299e' // Source: ../../../plugins/provideToast.ts (mode: 'client')
import nuxt_plugin_gtag_60b2ced0 from 'nuxt_plugin_gtag_60b2ced0' // Source: ../../../plugins/tracking/gtag.ts (mode: 'client')
import nuxt_plugin_cmp_71ccd1c6 from 'nuxt_plugin_cmp_71ccd1c6' // Source: ../../../plugins/cmp.ts (mode: 'client')
import nuxt_plugin_auth_700114d0 from 'nuxt_plugin_auth_700114d0' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_injectauth_0538bfe8 from 'nuxt_plugin_injectauth_0538bfe8' // Source: ../../../plugins/auth/inject_auth.ts (mode: 'all')
import nuxt_plugin_updateLanguageOnUserChange_27a8d6be from 'nuxt_plugin_updateLanguageOnUserChange_27a8d6be' // Source: ../../../plugins/auth/updateLanguageOnUserChange.ts (mode: 'all')
import nuxt_plugin_fireloginevent_193b173d from 'nuxt_plugin_fireloginevent_193b173d' // Source: ../../../plugins/auth/fire-login-event.ts (mode: 'all')
import nuxt_plugin_meta_6899bf7c from 'nuxt_plugin_meta_6899bf7c' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"viewport","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"og:title","property":"og:title","content":""},{"name":"og:site_name","property":"og:site_name","content":""}],"script":[{"src":"\u002Fassets\u002Fcmp.js"}],"link":[],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_b3e53afc === 'function') {
    await nuxt_plugin_plugin_b3e53afc(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_c46b1c2c === 'function') {
    await nuxt_plugin_plugin_c46b1c2c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_dee3e572 === 'function') {
    await nuxt_plugin_toast_dee3e572(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_13c46a8a === 'function') {
    await nuxt_plugin_portalvue_13c46a8a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_353ef0a3 === 'function') {
    await nuxt_plugin_pluginutils_353ef0a3(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_d1743da4 === 'function') {
    await nuxt_plugin_pluginrouting_d1743da4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_f7276dfe === 'function') {
    await nuxt_plugin_pluginmain_f7276dfe(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_b47f2098 === 'function') {
    await nuxt_plugin_workbox_b47f2098(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_d94e7a72 === 'function') {
    await nuxt_plugin_metaplugin_d94e7a72(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_77447ed0 === 'function') {
    await nuxt_plugin_axios_77447ed0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_01vxm_70479b39 === 'function') {
    await nuxt_plugin_01vxm_70479b39(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_02applyConfig_2aa97d93 === 'function') {
    await nuxt_plugin_02applyConfig_2aa97d93(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_styles_490d6f56 === 'function') {
    await nuxt_plugin_styles_490d6f56(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_directives_521c0486 === 'function') {
    await nuxt_plugin_directives_521c0486(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_dayjs_66ce609e === 'function') {
    await nuxt_plugin_dayjs_66ce609e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_dependencyinjectioncontainer_5d884c32 === 'function') {
    await nuxt_plugin_dependencyinjectioncontainer_5d884c32(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuefinalmodal_4feb7cf4 === 'function') {
    await nuxt_plugin_vuefinalmodal_4feb7cf4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_listofcountries_062e8d14 === 'function') {
    await nuxt_plugin_listofcountries_062e8d14(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fragment_0f1b35a7 === 'function') {
    await nuxt_plugin_fragment_0f1b35a7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_veevalidate_1a0c172c === 'function') {
    await nuxt_plugin_veevalidate_1a0c172c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_i18nextendmessages_2cf4d7f2 === 'function') {
    await nuxt_plugin_i18nextendmessages_2cf4d7f2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_assetsurl_121ce59c === 'function') {
    await nuxt_plugin_assetsurl_121ce59c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuequery_264a3842 === 'function') {
    await nuxt_plugin_vuequery_264a3842(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_handleconstraintviolations_74add344 === 'function') {
    await nuxt_plugin_handleconstraintviolations_74add344(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_provideToast_5ab8299e === 'function') {
    await nuxt_plugin_provideToast_5ab8299e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtag_60b2ced0 === 'function') {
    await nuxt_plugin_gtag_60b2ced0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cmp_71ccd1c6 === 'function') {
    await nuxt_plugin_cmp_71ccd1c6(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_700114d0 === 'function') {
    await nuxt_plugin_auth_700114d0(app.context, inject)
  }

  if (typeof nuxt_plugin_injectauth_0538bfe8 === 'function') {
    await nuxt_plugin_injectauth_0538bfe8(app.context, inject)
  }

  if (typeof nuxt_plugin_updateLanguageOnUserChange_27a8d6be === 'function') {
    await nuxt_plugin_updateLanguageOnUserChange_27a8d6be(app.context, inject)
  }

  if (typeof nuxt_plugin_fireloginevent_193b173d === 'function') {
    await nuxt_plugin_fireloginevent_193b173d(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_6899bf7c === 'function') {
    await nuxt_plugin_meta_6899bf7c(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
